import React from 'react'
import { AnalysisMap } from '@popety-io/ui'
import type { SectionType } from '../contexts'

export interface PublicEstimateMapProps {
  coordinates: [number, number]
  onResizeStart: () => void
  estimateData: any
  geoJson?: any
  buildingGeoJson?: any
  buildingHeight?: number
  activeSection?: SectionType
  sectionData?: any
  hoveredItemId?: string | number | null
  selectedItemId?: string | number | null
  flyToCoordinates?: [number, number] | null
  onItemClick?: ((item: any) => void) | null
  setSelectedItemId?: ((id: string | number | null) => void) | null
}

export const PublicEstimateMap: React.FC<PublicEstimateMapProps> = ({
  coordinates,
  onResizeStart,
  estimateData,
  geoJson,
  buildingGeoJson,
  buildingHeight,
  activeSection,
  sectionData,
  hoveredItemId,
  selectedItemId,
  flyToCoordinates,
  onItemClick,
  setSelectedItemId,
}) => {
  // Determine property ID based on estimate data
  const propertyId =
    estimateData?.value?.id ||
    estimateData?.value?.property_id ||
    estimateData?.value?.hash ||
    'estimate'

  // Determine analysis type based on estimate data
  const analysisType =
    estimateData?.value?.type === 'land'
      ? 'land'
      : estimateData?.value?.type === 'building'
        ? 'building'
        : 'property'

  return (
    <AnalysisMap
      isPublic
      propertyId={propertyId}
      coordinates={coordinates}
      analysisType={analysisType as any}
      onResizeStart={onResizeStart}
      geoJson={geoJson}
      buildingGeoJson={buildingGeoJson}
      buildingHeight={buildingHeight}
      activeSection={activeSection}
      sectionData={sectionData}
      hoveredItemId={hoveredItemId}
      selectedItemId={selectedItemId}
      flyToCoordinates={flyToCoordinates}
      onItemClick={onItemClick}
      setSelectedItemId={setSelectedItemId}
      uiConfig={{
        showLayersButton: true,
        showLegendButton: true,
        show3DButton: analysisType === 'building',
        showLocationButton: true,
        showZoomControls: true,
      }}
    />
  )
}
